import moment from 'moment';
import _ from 'lodash';
import Api from '../../../services/Api.js';
// Mutation Types
export const mutationTypes = {
    SET: 'SET',
    RESET: 'RESET'
};

export const currentFiscalYear = () => moment().format('Y')+'/'+moment().add(1, 'years').format('YY');

// Initial State
const state = {
    income: 0,
    pensionType: 'Gross',
    fiscalYear: currentFiscalYear(),
    total: 0,
    results: {}
};

// Getters
const getters = {
    income: state => state.income,
    all: state => state,
};

// Actions
const actions = {
    set({commit, dispatch}, { key, value }) {
        commit(mutationTypes.SET, { key, value });
        dispatch('calculatePension');
    },
    calculatePension: _.debounce(({ dispatch, state }) => {
        if (moment(state.fiscalYear, 'YYYY/YY').isValid() && state.income > 0 && (state.pensionType == 'NET' || state.pensionType == 'Gross')) {
            return Api.miniCalculators.grossNetPension.calculate(state)
                .then(data => {
                    dispatch('setTotal', data);
                });
        }
    }, 500),
    setTotal({commit}, data) {
        commit(mutationTypes.SET, { key: 'results', value: data });
    },
    reset({ commit }) {
        commit(mutationTypes.RESET);
    },
};

// Mutations 
const mutations = {
    [mutationTypes.SET] (state, {key, value}) {
        state[key] = value;
    },
    [mutationTypes.RESET] (state) {
        state.income = 0;
        state.pensionType = 'Gross';
        state.fiscalYear = currentFiscalYear();
        state.total = 0;
        state.results = {};
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/mini/pension.js